import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Constants from '../constants';
import Tabs from '../components/Tabs/Tabs';
import Header from '../components/Header/Header';
import Cart from '../containers/Cart/Cart';
import DiagnosticsCart from '../containers/DiagnosticsCart/DiagnosticsCart';
import DocConsultRHS from '../components/DocConsultRHS/DocConsultRHS';
import ServiceRHS from './Services/ServiceRHS';
import * as actions from '../actions';
import TagManager from 'react-gtm-module';
import ClevertapReact from 'clevertap-react';
import { setDeviceFingerprint } from '@utils/helper';

import "./App.scss";
import {
  Modal,
  ModalBody,
  ModalFooter
} from 'react-modal-bootstrap';
class App extends Component {
  constructor(props) {
    super(props);
    const gtmArgs = {
      gtmId: Constants.GTM_CONTAINER_ENV_MAP[process.env.NODE_ENV],
    }
    const clevertapAccount = process.env.NODE_ENV == 'production' ? "RZK-947-RW6Z" : "TEST-K9Z-WWR-854Z";
    TagManager.initialize(gtmArgs);
    ClevertapReact.initialize(clevertapAccount);
    this.state = { isOpen: false };
  }
  componentWillReceiveProps(newProps) {
    if (newProps.action.type == this.props.action.type) {
      return;
    }
    switch (newProps.action.type) {
      case Constants.OPEN_HELP_POPUP:
        this.openModal();
        break;
      case Constants.CLOSE_POPUP:
        this.hideModal();
        break;
    }
  }

  documentKeyupHandler(event) {
    if (event.target.nodeName === 'INPUT') {
      return;
    }
    switch (event.which) {
      case 27:
        this.props.actions.hotkeysPress({ type: Constants.CLOSE_POPUP });
        break;
      case 191:
        event.shiftKey && this.props.actions.hotkeysPress({ type: Constants.OPEN_HELP_POPUP });
        event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.MEDICINE_SEARCH, path: window.location.pathname });;
        break;
      case 38:
        !event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.UP_ARROW, path: window.location.pathname });
        event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.PLUS, path: window.location.pathname });
        break;
      case 40:
        !event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.DOWN_ARROW, path: window.location.pathname });
        event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.MINUS, path: window.location.pathname });
        break;
      case 187:
        event.shiftKey && this.props.actions.hotkeysPress({ type: Constants.PLUS, path: window.location.pathname });
        break;
      //shit+
      case 189:
        event.shiftKey && this.props.actions.hotkeysPress({ type: Constants.MINUS, path: window.location.pathname });
        break;
      //shift-
      case 13:
        //enter
        if (event.target.name == "promobox") {
          this.props.actions.hotkeysPress({ type: Constants.APPLY_COUPON, path: window.location.pathname });
          return;
        }
        this.props.actions.hotkeysPress({ type: Constants.RETURN, path: window.location.pathname });
        break;
      case 221:
        //shift+}
        event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.TAB_MOVE_RIGHT, path: window.location.pathname });
        event.altKey && this.props.actions.hotkeysPress({ type: Constants.TAB_MOVE_RIGHT, path: window.location.pathname });
        break;
      case 219:
        //shift+{
        event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.TAB_MOVE_LEFT, path: window.location.pathname });
        event.altKey && this.props.actions.hotkeysPress({ type: Constants.TAB_MOVE_LEFT, path: window.location.pathname });
        break;
      case 188:
        event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.MOVE_BACKWARD, path: window.location.pathname });
        break;
      case 190:
        event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.MOVE_FORWARD, path: window.location.pathname });
        break;
      case 68:
        //shift+d discount input active
        event.shiftKey && this.props.actions.hotkeysPress({ type: Constants.DISCOUNT_COUPON, path: window.location.pathname });
        break;
      case 80:
        //shift+p place order
        event.shiftKey && this.props.actions.hotkeysPress({ type: Constants.PLACE_ORDER, path: window.location.pathname });
        break;
      case 67:
        //shift+c cancel order
        event.shiftKey && this.props.actions.hotkeysPress({ type: Constants.CLOSE_THIS_TASK, path: window.location.pathname });
        break;
      case 82:
        //shift+r  select prescriptions
        event.shiftKey && this.props.actions.hotkeysPress({ type: Constants.SELECT_PRESCRIPTIONS, path: window.location.pathname });
        break;
      case 65:
        //shift+a  select address
        event.ctrlKey && this.props.actions.hotkeysPress({ type: Constants.ADD_NEW_ADDRESS, path: window.location.pathname });
        break;
      case 37:
        //left arrow
        this.props.actions.hotkeysPress({ type: Constants.LEFT_ARROW, path: window.location.pathname });
        break;
      case 39:
        //right now
        this.props.actions.hotkeysPress({ type: Constants.RIGHT_ARROW, path: window.location.pathname });
        break;
    }
  }
  componentDidMount() {
    setDeviceFingerprint();
    document.addEventListener('keyup', () => { this.documentKeyupHandler(event) });
  }
  componentWillUnmount() {
    document.removeEventListener("keyup", this.documentKeyupHandler);
  }
  openModal = () => {
    this.setState({
      isOpen: true
    });
  }
  hideModal = () => {
    this.setState({
      isOpen: false
    });
  }
  renderRHS() {
    const pathname = window && window.location.pathname;
    const isServicePlatform = pathname.startsWith('/services/') && pathname.endsWith('/slot-patient');
    const isDocConsultSummary = pathname === '/doc-consult/slot-patient';

    if (isServicePlatform) return <ServiceRHS />;
    if (isDocConsultSummary) return <DocConsultRHS />;
    if (this.props.orderType) return <DiagnosticsCart />;
    return <Cart />;
  }
  render() {
    const pathname = window && window.location.pathname;
    const hideRHS = pathname === '/customer-info' ||
      pathname === '/doc-consult/select-speciality' ||
      pathname === '/doc-consult/select-doctor' ||
      pathname.endsWith('/select-package');
    return (
      <div className="layoutContainer">
        {this.props.isAuthenticated ?
          <div>
            <Modal isOpen={this.state.isOpen} onRequestHide={this.hideModal.bind(this)} backdrop={false}>
              <ModalBody>
                <div>
                  <div>Global Shortcuts:</div>
                  <ul>
                    <li><span className="boldText">List of Keyboard shortcuts: </span><span>Shift + /[?]</span></li>
                    <li><span className="boldText">Move to next field/action button: </span><span>Tab</span></li>
                    <li><span className="boldText">Close Modal: </span><span>Esc</span></li>
                    <li><span className="boldText">Close current task: </span><span>Ctrl + C</span></li>
                    <li><span className="boldText">Quick medicine search: </span><span>Ctrl + /</span></li>
                  </ul>
                </div>
                <div>
                  <div>Navigation Shortcuts:</div>
                  <ul>
                    <li><span className="boldText">Move to next page from home page:  </span><span>Enter</span></li>
                    <li><span className="boldText">Move to add products page </span><span>Enter</span></li>
                    <li><span className="boldText">Previous Page:  </span><span>Ctrl + &#60;</span></li>
                    <li><span className="boldText">Next Page:  </span><span>Ctrl + &#62;</span></li>
                    <li><span className="boldText">move up in results dropdown options:</span> <span>Up-Arrow</span></li>
                    <li><span className="boldText">Move down in results Dropdown options: </span><span>Down-Arrow</span></li>
                    <li><span className="boldText">Move between tabs in a page: </span><span>Ctrl + [ and Ctrl + ] might be back or forward for Browser, in that case we can add Alt to the combination</span></li>
                    <li><span className="boldText">Move to next page from home page:  </span><span>Tab</span></li>
                    <li><span className="boldText">Move backward sections:</span><span>Shift +Tab</span></li>
                  </ul>
                </div>
                <div>
                  <div>Action Shortcuts:</div>
                  <ul>
                    <li><span className="boldText">Ctrl+A: </span><span>Add new Address</span></li>
                    <li><span className="boldText">shift+R: </span><span>Select rx available field</span></li>
                    <li><span className="boldText">Shift+P: </span><span>Place an Order</span></li>
                    <li><span className="boldText">Shift+D: </span><span>Focus on coupon field </span></li>
                    <li><span className="boldText">Save and Proceed/Continue: </span><span>Enter</span></li>
                    <li><span className="boldText">Reduce order quantity/Selected Product: </span><span>Ctrl + Up ARROW</span></li>
                    <li><span className="boldText">Move forward sections: </span><span>Ctrl + Down ARROW</span></li>
                    <li><span className="boldText">Select checkbox: </span><span>Space</span></li>
                    <li><span className="boldText">Select radiobutton: </span><span>Left or Right arrow</span></li>
                  </ul>
                </div>
              </ModalBody>
              <ModalFooter>`
              <button className='btn btn-default' onClick={this.hideModal.bind(this)}>Close</button>
              </ModalFooter>
            </Modal>
            <Header {...this.props} />
            <div style={{ display: 'flex', width: '100%' }}>
              <div className="LHSContainer">
                <Tabs {...this.props} orderType={this.props.orderType} />
                {this.props.children}
              </div>
              {!hideRHS && (<div className="RHSContainer">
                {this.renderRHS()}
              </div>)}
            </div>
          </div> :
          <div style={{ width: '100%' }}>{this.props.children}</div>}
      </div>);
  }
}

App.propTypes = {
  user: PropTypes.object.isRequired,
  tabs: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool,
  orderType: PropTypes.number,
};

App.defaultProps = {
  isAuthenticated: false,
  orderType: 0,
};

export default connect(state => ({
  user: state.user,
  tabs: state.tabs,
  orderType: state.orderParams.orderType,
  isAuthenticated: state.user.isLoggedIn,
  action: state.action
})
  , dispatch => ({
    actions: bindActionCreators(actions, dispatch)
  }))(App);
